module.exports = __webpack_public_path__ + "img/bus-sentosa.e3a32da2.svg";